import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { useIsHomeHealthWorkplaceMobileExperienceEnabled } from "@src/appV2/ExperimentalHomeHealth/lib/useIsHomeHealthWorkplaceMobileExperienceEnabled";
import { useIsMobileDevice } from "@src/appV2/redesign/AppLayout/useResponsive";
import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { useCurrentUserId } from "../lib/useCurrentUserId";
import { useIsHomeHealthEnabled } from "../lib/useIsHomeHealthEnabled";
import { MobileCasesListContainer } from "./components/MobileCasesListContainer";
import { HOME_HEALTH_CASES_PATH } from "./paths";

const CasesPage = lazy(
  async () =>
    await import("./CasesPage").then((module) => ({
      default: module.CasesPage,
    }))
);

export function HomeHealthProtectedCasesPage() {
  const currentUserId = useCurrentUserId();
  const isLoggedIn = isDefined(currentUserId);
  const isHomeHealthEnabled = useIsHomeHealthEnabled();
  const isMobile = useIsMobileDevice();
  const isHomeHealthWorkplaceMobileExperienceEnabled =
    useIsHomeHealthWorkplaceMobileExperienceEnabled();

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", HOME_HEALTH_CASES_PATH);
    return <Redirect to={`/enter?requestedUrl=${HOME_HEALTH_CASES_PATH}`} />;
  }

  if (!isHomeHealthEnabled) {
    localStorage.removeItem("redirectURL");
    return <Redirect to="/" />;
  }

  if (isMobile && isHomeHealthWorkplaceMobileExperienceEnabled) {
    return (
      <BerlinThemeProvider fullHeight>
        <MobileCasesListContainer />
      </BerlinThemeProvider>
    );
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <CasesPage />
    </Suspense>
  );
}
